import {initMaskedInput, initPlaceholders} from "../helpers/inputs";
import {initFormWithValidate, validateForm} from "../helpers/validator";

export function initForm(){
    const $form = $('#feedback_form');
    const $submitBtn = $('#submit_btn');
    const $repeatBtn = $('#repeat_btn');
    const $status = $('.status-block');

    if(!$form.length) return;

    init();

    function init(){
        initPlaceholders();
        initMaskedInput();
        initFormWithValidate($form);
        initHandlers();
    }

    function initHandlers(){
        $form.submit((e) => {
            onSubmit(e);
        });

        $repeatBtn.on('click', e => {
            $form[0].reset();
            closeErrorModal();
        });
    }

    function onSubmit(e){
       e.preventDefault();

        if(validateForm($form, true)){
            const data = {}

            $form.find('input, textarea').each((_,input) => {
                const $input = $(input);

                data[$input.attr('name')] = $input.val();
            })

            //доп верификация от роботов (ну типа верификация)
            data.verification = '1';

            $submitBtn.addClass('disabled');

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'text',
                data: data,
                success: res => {
                    $status.addClass('success-status');
                    $form[0].reset();
                },
                error: res => {
                    $status.addClass('error-status');
                    $form[0].reset();
                },
                timeout: 30000
            });
        }
    }

    function closeErrorModal(){
        $status.removeClass('error-status');
    }
}